<div class="promos-container">
    <finder-promo *ngFor="let promo of promos"
        class="promo"
        [icon]="promo.icon"
        [title]="promo.title"
        [subtitle]="promo.subtitle"
        [buttonText]="promo.buttonText"
        [link]="promo.link"
        [background]="promo.background"
        [tooltipText]="promo.tooltip">
    </finder-promo>
</div>
